import { IInitialNotificationStatus } from '../../models/NotificationModels';
import { ICreateAccountPayload, IPinAccountPayload } from '../../models/OverviewModels';
import { API_ROUTE } from '../ApiRoute';
import ApiService from '../ApiService';
import ApiServiceBase from '../ApiServiceBase';
import { ServerType, ServiceType } from '../ServiceType.data';
import { IMultipartFormData } from '../MultipartFormData.data';

const serviceType = ServiceType.None;

export class OverViewService {
  private readonly service: ApiServiceBase = new ApiService(serviceType, ServerType.tangra);

  private readonly dcaBackendService: ApiServiceBase = new ApiService(
    ServiceType.None,
    ServerType.dcaBackend,
  );

  public createAccount(payload: ICreateAccountPayload): Promise<string> | string {
    const route: string[] = [API_ROUTE.ACCOUNT.BASE, API_ROUTE.PROJECT.BASE];
    return this.service.post({ route: route }, { ...payload });
  }

  public addAccount(payload: IMultipartFormData): Promise<string> | string {
    const route: string[] = [API_ROUTE.ACCOUNT.CREATE];
    return this.dcaBackendService.postMultipart({ route: route }, [payload]);
  }

  public addProject(payload: IMultipartFormData): Promise<string> | string {
    const route: string[] = [API_ROUTE.PROJECT.CREATE];
    return this.dcaBackendService.postMultipart({ route: route }, [payload]);
  }

  public editProject(payload: IMultipartFormData): Promise<string> | string {
    const route: string[] = [API_ROUTE.PROJECT.UPDATE];
    return this.dcaBackendService.postMultipart({ route: route }, [payload]);
  }
  public getNotificationStatus(): Promise<IInitialNotificationStatus> | IInitialNotificationStatus {
    return this.dcaBackendService.get({ route: [API_ROUTE.NOTIFICATION_STATUS] });
  }
  public pinAccount(
    payload: IPinAccountPayload,
  ): Promise<IInitialNotificationStatus> | IInitialNotificationStatus {
    return this.dcaBackendService.post(
      { route: [API_ROUTE.PIN_ACCOUNT] },
      {
        ...payload,
      },
    );
  }
}

const overViewService = new OverViewService();
export default overViewService;
